import {NgModule} from '@angular/core';
import {PipesModule as InsparkPipesModule} from '@inspark/inspark-components';
import { DropdownOptionsPrepPipe } from './dropdown-options-prep.pipe';
import { FilterPipe } from './filter.pipe';

/**
 * Re-exports inspark's PipesModule so existing consumers keep getting
 * PropertyValuePipe, InDate, FormatNumToTime, etc. without duplication.
 * Declares only the app-local pipes that inspark does not provide.
 */
@NgModule({
  imports: [InsparkPipesModule],
  exports: [InsparkPipesModule, DropdownOptionsPrepPipe, FilterPipe],
  declarations: [DropdownOptionsPrepPipe, FilterPipe]
})
export class PipesModule {
}
